import React from 'react'
import { useQuery } from '@apollo/react-hooks'
import _ from 'lodash'
import numeral from 'numeral'
import moment from 'moment'
import {
  Div, P, Loading,
} from 'konsys-ui'
import { theme } from '../../../styles/_variables'
import { GET_JOB_FOR_CUSTOMER } from '../../../constants/graphql/query'
import COMAPNY_NAME from '../../../constants/company-name'
import { unitText } from '../constants'

const { color } = theme

const CustomerJobDetail = ({ props }) => {
  const {
    data: jobData, loading: jobLoading, error,
  } = useQuery(GET_JOB_FOR_CUSTOMER, { variables: { id: props.match.params.id } })
  if (jobLoading || _.isEmpty(jobData)) return <Loading center='true' />
  if (error) return <P>เกิดข้อผิดพลาด</P>
  return (
    <Div>
      <Div
        display='flex' flexDirection='row' alignItems='center' padding='32px 0 40px 0' style={{ borderBottom: `1px solid ${color.paleGrey}` }}
      >
        <Div width='30%' display='flex' flexDirection='column'>
          <P margin='0 0 16px'>บริษัท</P>
          <P margin='0 0 16px'>{COMAPNY_NAME[jobData?.JobInfo?.companyType]}</P>
        </Div>
        <Div width='15%' display='flex' flexDirection='column'>
          <P margin='0 0 16px'>เลขที่สัญญางาน</P>
          <P margin='0 0 16px'>{jobData?.JobInfo?.number}</P>
        </Div>
        <Div width='15%'>
          <P margin='0 0 16px' display='block'>วันที่เริ่มอายุสัญญา</P>
          <P margin='0 0 16px'>{moment(jobData?.JobInfo?.contractStart).format('YYYY/MM/DD')}</P>
        </Div>
        <Div width='15%'>
          <P margin='0 0 16px' display='block'>วันที่หมดอายุสัญญา</P>
          <P margin='0 0 16px'>{moment(jobData?.JobInfo?.contractEnd).format('YYYY/MM/DD')}</P>
        </Div>
      </Div>
      <Div
        display='flex' flexDirection='row' alignItems='center' padding='32px 0 40px 0' style={{ borderBottom: `1px solid ${color.paleGrey}` }}
      >
        <Div width='30%' display='flex' flexDirection='column'>
          <P margin='0 0 16px'>ผู้จ้าง</P>
          <P margin='0 0 16px'>{jobData?.JobInfo?.Customer?.companyName}</P>
        </Div>
        <Div width='30%' display='flex' flexDirection='column'>
          <P margin='0 0 16px'>ต้นทาง</P>
          <P margin='0 0 16px'>{jobData?.JobInfo?.startDestinationLocation?.name}</P>
        </Div>
        <Div width='30%' display='flex' flexDirection='column'>
          <P margin='0 0 16px'>ปลายทาง</P>
          <P margin='0 0 16px'>{jobData?.JobInfo?.endDestinationLocation?.name}</P>
        </Div>
      </Div>
      <Div
        display='flex' flexDirection='row' alignItems='center' padding='32px 0 40px 0' style={{ borderBottom: `1px solid ${color.paleGrey}` }}
      >
        <Div width='15%' display='flex' flexDirection='column'>
          <P margin='0 0 16px'>ประเภทสินค้า</P>
          <P margin='0 0 16px'>{jobData?.JobInfo?.cargo}</P>
        </Div>
        <Div width='15%' display='flex' flexDirection='column'>
          <P margin='0 0 16px'>น้ำหนัก/เที่ยวทั้งหมด</P>
          <P margin='0 0 16px'>{numeral(jobData?.JobInfo?.contractWeight).format('0,0.00')}</P>
        </Div>
        <Div width='15%' display='flex' flexDirection='column'>
          <P margin='0 0 16px'>น้ำหนัก/เที่ยวที่ขนส่งแล้ว</P>
          <P margin='0 0 16px'>{numeral(jobData?.JobInfo?.deliveredWeight).format('0,0.00')}</P>
        </Div>
        <Div width='15%' display='flex' flexDirection='column'>
          <P margin='0 0 16px'>หน่วย</P>
          <P margin='0 0 16px'>{unitText[jobData?.JobInfo?.unit]}</P>
        </Div>
      </Div>
    </Div>
  )
}

export default CustomerJobDetail
export { CustomerJobDetail }
